import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useParcours } from "../../context/ParcoursContext";
import { AttentionSelectiveExercise } from "../../modules/pratiquer/Cognitif/AttentionSelectiveExercise";

export default function ParcoursPlayStep() {
  const { parcoursId, stepId } = useParams<{ parcoursId: string; stepId: string }>();
  const navigate = useNavigate();
  const { markStepCompleted, isGuest } = useParcours();

  const handleMark = () => {
    if (!parcoursId || !stepId) return;
    if (isGuest) {
      alert("Connectez-vous pour marquer l'étape comme terminée.");
      return;
    }
    markStepCompleted(parcoursId, stepId);
  };

  return (
    <main className="max-w-4xl mx-auto py-8 px-4 space-y-4">
      <h1 className="text-2xl font-semibold">Mini-jeu du parcours</h1>
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Placeholder Play : on réutilise l'exercice d'attention sélective comme démo.
      </p>
      <AttentionSelectiveExercise />
      <div className="flex gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-semibold"
          onClick={handleMark}
        >
          Marquer cette étape comme terminée
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded-lg border text-sm font-semibold"
          onClick={() => navigate(`/parcours/${parcoursId}`)}
        >
          Revenir au parcours
        </button>
      </div>
      {/* TODO MixMind: brancher un mini-jeu dédié pour cette étape Play. */}
    </main>
  );
}
